const mockedData = [
  {
    calibrations: [
      {
        appVolume: 0.003311311432966782,
        masterVolume: 0.5,
        freq: 500,
        intensityTestedAgainst: 20.0,
      },
      {
        appVolume: 3.1260795730622177e-4,
        masterVolume: 0.5,
        freq: 2000,
        intensityTestedAgainst: 20.0,
      },
      {
        appVolume: 0.001708047832581605,
        masterVolume: 0.5,
        freq: 1000,
        intensityTestedAgainst: 20.0,
      },
      {
        appVolume: 0.0026302680027250973,
        masterVolume: 0.5,
        freq: 4000,
        intensityTestedAgainst: 20.0,
      },
    ],
    createdAt: 1734355087.434,
    type: "metrological",
    id: "6760288f9273135eaef9cda8",
    deviceId: "ED98648F-EED7-4197-A048-3C8A2AD6F9CA",
    manufacturer: "Apple",
    brand: "Apple",
    model: "iPhone 11",
    userId: "714e8c57-609d-41d5-9230-69927a06f3fe",
    calibratorName: "Jan Kowalski",
  },
  {
    calibrations: [
      {
        appVolume: 3.1260795730622177e-4,
        masterVolume: 0.5,
        freq: 2000,
        intensityTestedAgainst: 20.0,
      },
      {
        appVolume: 0.003311311432966782,
        masterVolume: 0.5,
        freq: 500,
        intensityTestedAgainst: 20.0,
      },
      {
        appVolume: 0.001708047832581605,
        masterVolume: 0.5,
        freq: 1000,
        intensityTestedAgainst: 20.0,
      },
      {
        appVolume: 0.0026302680027250973,
        masterVolume: 0.5,
        freq: 4000,
        intensityTestedAgainst: 20.0,
      },
    ],
    createdAt: 1734355087.434,
    type: "metrological",
    id: "6760288f9273135eaef9cda8",
    deviceId: "ED98648F-EED7-4197-A048-3C8A2AD6F9CA",
    manufacturer: "Apple",
    brand: "Apple",
    model: "iPhone 11",
    userId: "714e8c57-609d-41d5-9230-69927a06f3fe",
    calibratorName: "Jan Kowalski",
  },
  {
    calibrations: [
      {
        appVolume: 3.1260795730622177e-4,
        masterVolume: 0.5,
        freq: 2000,
        intensityTestedAgainst: 20.0,
      },
      {
        appVolume: 0.003311311432966782,
        masterVolume: 0.5,
        freq: 500,
        intensityTestedAgainst: 20.0,
      },
      {
        appVolume: 0.001708047832581605,
        masterVolume: 0.5,
        freq: 1000,
        intensityTestedAgainst: 20.0,
      },
      {
        appVolume: 0.0026302680027250973,
        masterVolume: 0.5,
        freq: 4000,
        intensityTestedAgainst: 20.0,
      },
    ],
    createdAt: 1734355087.434,
    type: "metrological",
    id: "6760288f9273135eaef9cda8",
    deviceId: "ED98648F-EED7-4197-A048-3C8A2AD6F9CA",
    manufacturer: "Apple",
    brand: "Apple",
    model: "iPhone 11",
    userId: "714e8c57-609d-41d5-9230-69927a06f3fe",
    calibratorName: "Jan Kowalski",
  },
  {
    calibrations: [
      {
        appVolume: 3.1260795730622177e-4,
        masterVolume: 0.5,
        freq: 2000,
        intensityTestedAgainst: 20.0,
      },
      {
        appVolume: 0.003311311432966782,
        masterVolume: 0.5,
        freq: 500,
        intensityTestedAgainst: 20.0,
      },
      {
        appVolume: 0.001708047832581605,
        masterVolume: 0.5,
        freq: 1000,
        intensityTestedAgainst: 20.0,
      },
      {
        appVolume: 0.0026302680027250973,
        masterVolume: 0.5,
        freq: 4000,
        intensityTestedAgainst: 20.0,
      },
    ],
    createdAt: 1734355087.434,
    type: "metrological",
    id: "6760288f9273135eaef9cda8",
    deviceId: "ED98648F-EED7-4197-A048-3C8A2AD6F9CA",
    manufacturer: "Apple",
    brand: "Apple",
    model: "iPhone 11",
    userId: "714e8c57-609d-41d5-9230-69927a06f3fe",
    calibratorName: "Jan Kowalski",
  },
  {
    calibrations: [
      {
        appVolume: 3.1260795730622177e-4,
        masterVolume: 0.5,
        freq: 2000,
        intensityTestedAgainst: 20.0,
      },
      {
        appVolume: 0.003311311432966782,
        masterVolume: 0.5,
        freq: 500,
        intensityTestedAgainst: 20.0,
      },
      {
        appVolume: 0.001708047832581605,
        masterVolume: 0.5,
        freq: 1000,
        intensityTestedAgainst: 20.0,
      },
      {
        appVolume: 0.0026302680027250973,
        masterVolume: 0.5,
        freq: 4000,
        intensityTestedAgainst: 20.0,
      },
    ],
    createdAt: 1734355087.434,
    type: "metrological",
    id: "6760288f9273135eaef9cda8",
    deviceId: "ED98648F-EED7-4197-A048-3C8A2AD6F9CA",
    manufacturer: "Apple",
    brand: "Apple",
    model: "iPhone 11",
    userId: "714e8c57-609d-41d5-9230-69927a06f3fe",
    calibratorName: "Jan Kowalski",
  },
  {
    calibrations: [
      {
        appVolume: 3.1260795730622177e-4,
        masterVolume: 0.5,
        freq: 2000,
        intensityTestedAgainst: 20.0,
      },
      {
        appVolume: 0.003311311432966782,
        masterVolume: 0.5,
        freq: 500,
        intensityTestedAgainst: 20.0,
      },
      {
        appVolume: 0.001708047832581605,
        masterVolume: 0.5,
        freq: 1000,
        intensityTestedAgainst: 20.0,
      },
      {
        appVolume: 0.0026302680027250973,
        masterVolume: 0.5,
        freq: 4000,
        intensityTestedAgainst: 20.0,
      },
    ],
    createdAt: 1734355087.434,
    type: "metrological",
    id: "6760288f9273135eaef9cda8",
    deviceId: "ED98648F-EED7-4197-A048-3C8A2AD6F9CA",
    manufacturer: "Apple",
    brand: "Apple",
    model: "iPhone 11",
    userId: "714e8c57-609d-41d5-9230-69927a06f3fe",
    calibratorName: "Jan Kowalski",
  },
];
export default mockedData;
